import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import styles from './Breadcrumb.module.css';

// items: [{ label, path }] — the last item is always rendered as the current
// (non-clickable) page, regardless of whether it carries a path.
const Breadcrumb = ({ items }) => (
  <nav className={styles.breadcrumb} aria-label="Breadcrumb">
    {items.map((item, i) => {
      const isLast = i === items.length - 1;
      return (
        <Fragment key={item.label}>
          {isLast || !item.path ? (
            <span className={isLast ? styles.current : styles.link}>{item.label}</span>
          ) : (
            <Link to={item.path} className={styles.link}>{item.label}</Link>
          )}
          {!isLast && <span className={styles.separator}>/</span>}
        </Fragment>
      );
    })}
  </nav>
);

export default Breadcrumb;
